// extracted by mini-css-extract-plugin
module.exports = {"root":"Images45_root__2GQ-j","title":"Images45_title__2uFGm","images":"Images45_images__3yW5j"};